// @ts-nocheck
import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Table } from 'reactstrap';
import ModalForm from '../../comum/components/ModalForm'


@observer
export default class ModalVesselVisit extends Component {

    constructor(props) {

        super(props)

        this.controller = this.props.controller
        this.dados = this.controller.dadosVesselVisit
    }

    render() {
        
        return (
            <ModalForm
                className="tamanho-modal-acomproc"
                esconderSalvar={true}
                labelCancelar="FECHAR"
                onClickCancelar={() => this.controller.fecharModalVesselVisit()}
            >
            { this.dados ? 
            
                <Table className="mx-0 px-0 tabela" striped borderless>
                    <thead >
                        <tr>
                            <th className="small-title" colSpan="2" width="100%"><b>Detalhes da Operação</b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="small-title linha borda" colSpan="2" align="center"><b>Dados Gerais</b></td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%"><strong>Serviço</strong></td>
                            <td className="small-col-data" width="50%">{this.dados.ServicoNome}</td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Previsão de Início</td>
                            <td className="small-col-data" width="50%">{this.dados.EtaFormat}</td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Previsão de Final</td>
                            <td className="small-col-data" width="50%">{this.dados.EtdFormat}</td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Atracação Real</td>
                            <td className="small-col-data" width="50%">{this.dados.ChegadaRealFormat}</td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Início Real</td>
                            <td className="small-col-data" width="50%">{this.dados.InicioRealFormat}</td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Fim Real</td>
                            <td className="small-col-data" width="50%">{this.dados.FimRealFormat}</td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Desatracação</td>
                            <td className="small-col-data" width="50%">{this.dados.PartidaRealFormat}</td>
                        </tr>
                        {process.env.ssa && <tr>
                            <td className="small-col" width="50%">Liberação RFB</td>
                            <td className="small-col-data" width="50%">{this.dados.LiberacaoFormat}</td>
                        </tr>}
                        <tr>
                            <td className="small-title linha" colSpan="2" align="center"><b>Recebimento da Carga e Container</b></td>
                        </tr>
                        <tr>
                            <td className="small-col" width="50%">Início</td>
                            <td className="small-col-data" width="50%">{this.dados.InicioRecebCheioFormat}</td>
                        </tr>
                        <tr>
                            <td className="small-col linha borda" width="50%">Deadline</td>
                            <td className="small-col-data linha borda" width="50%">{this.dados.DeadlineDryFormat}</td>
                        </tr>
                    </tbody>
                </Table>
            :
            <h2>Nenhum dado encontrado sobre o Navio</h2>
            }
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/ModalVesselVisit.js